(function () {
  const root    = document.getElementById('account-invite-root');
  if (!root) return;

  const form    = document.getElementById('invite-form');
  const emailEl = document.getElementById('InviteEmail');
  const btn     = document.getElementById('invite-submit');
  const alertEl = document.getElementById('invite-alert');

  const PROXY_URL = `${window.Shopify?.routes?.root || '/'}apps/bridge/customer/invitation/`;

  function showAlert(kind, msg) {
    alertEl.hidden = false;
    // riuso stile error/success del tema se esiste; altrimenti mostro testo semplice
    alertEl.classList.remove('is-success', 'is-warning', 'is-error');
    if (kind === 'success') alertEl.classList.add('is-success');
    if (kind === 'warning') alertEl.classList.add('is-warning');
    if (kind === 'error')   alertEl.classList.add('is-error');
    alertEl.textContent = msg;
  }

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    alertEl.hidden = true;

    const email = (emailEl.value || '').trim();
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      showAlert('warning', window.theme?.strings?.invalidEmail || window.account_invite_invalid || 'Inserisci un’email valida.');
      return;
    }

    btn.disabled = true;
    const prev = btn.textContent;
    btn.textContent = (window.account_invite_sending || 'Invio...');

    try {
      const res = await fetch(PROXY_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      const data = await res.json().catch(() => ({}));

      if (res.status === 200) {
        switch (data.action) {
          case 'invite_sent':
            showAlert('success', window.account_invite_invite_sent || 'Invito inviato! Controlla la casella email.');
            break;
          case 'already_invited':
            showAlert('warning', window.account_invite_already_invited || 'Hai già un invito in sospeso. Controlla anche lo spam.');
            break;
          case 'already_enabled':
            showAlert('warning', window.account_invite_already_enabled || 'Account già attivo. Prova ad accedere o reimposta la password.');
            break;
          default:
            showAlert('success', window.account_invite_ok_generic || 'Operazione completata.');
        }
      } else if (res.status === 404) {
        showAlert('error', window.account_invite_not_found || 'Nessun account trovato per questa email.');
      } else {
        showAlert('error', window.account_invite_server_error || 'Errore imprevisto. Riprova.');
      }
    } catch (err) {
      showAlert('error', window.account_invite_network_error || 'Problema di rete. Riprova.');
    } finally {
      btn.disabled = false;
      btn.textContent = prev;
    }
  });
})();